import cn from 'classnames'

import Icon from '@components/Icon'
import { MSG_WARNING, MSG_TYPES, MSG_INFO } from './constants'

export { MSG_WARNING, MSG_INFO }

import styles from './styles.module.scss'

const ICON_MAP = {
    [MSG_WARNING]: 'alert',
    [MSG_INFO]: 'info',
}

const MessageBox = ({ children, type, className }) => {
    const fullClassName = cn(styles.messageBox, styles[type], className)

    return (
        <div className={fullClassName}>
            <div className={styles.icon}>
                <Icon type={ICON_MAP[type]} size="xs" />
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    )
}

MessageBox.propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(MSG_TYPES).isRequired,
}

export default MessageBox
